"use client";

import { deleteCookie } from "cookies-next";
import React from "react";
import { cookieConsentName } from "./CookieConsent";
import { usePathname, useRouter } from "next/navigation";

const CookieSettingsLink: React.FC = () => {
  const pathname = usePathname();
  const router = useRouter();

  const removeCookieSettings = () => {
    if (pathname == "/cookies") {
      router.push("/");
      return;
    }

    deleteCookie(cookieConsentName);
    if (window) {
      window.location.reload();
    }
  };

  return (
    <div
      className="cursor-pointer hover:underline"
      onClick={removeCookieSettings}
    >
      Cookie-indstillinger
    </div>
  );
};

export default CookieSettingsLink;
